import React from 'react';
import styles from './styles/styles.module.scss';
import Logo from '../../../../../assets/images/partners-logos/1_Percent_Logo_@2x.png';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: { PROUD_ONE_PERCENTER }
  }
} = StringConstantsMixin;

const OnePercentForThePlanet = () => {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <img src={Logo} className={styles.logo} alt="1% for the planet" />
        <div className={styles.subText}>{PROUD_ONE_PERCENTER}</div>
      </div>
    </section>
  );
};

export default OnePercentForThePlanet;
